export enum Event3sType {
  ResponseReceived = "ResponseReceived",
  ResultsRendered = "ResultsRendered",
  SearchEntityClicked = "SearchEntityClicked",
  SearchEntityActions = "SearchEntityActions",
  ClientLayout = "ClientLayout",
  EntityActionTaken = "EntityActionTaken",
  ChevronClicked = "ChevronClicked",
  SearchActions = "SearchActions",
}

export enum SearchActionEventType {
  searchBoxFocus = "searchBoxFocus",
  ExitSearch = "ExitSearch",
  VerticalClicked = "VerticalClicked",
  ClearSearchText = "ClearSearchText",
}

export function isSearchActionEventType(
  event: string | undefined
): event is SearchActionEventType {
  switch (event) {
    case SearchActionEventType.searchBoxFocus:
    case SearchActionEventType.ExitSearch:
    case SearchActionEventType.VerticalClicked:
    case SearchActionEventType.ClearSearchText:
      return true;
    default:
      return false;
  }
}

export enum EntityActionTakenType {
  CopyLink = "CopyLink",
  SendCopy = "SendCopy",
  Share = "Share",
  Download = "Download",
  Unsubscribe = "Unsubscribe",
}

export enum ScrollbarMovementType {
  Up = "Up",
  Down = "Down",
  Left = "Left",
  Right = "Right",
}
